const METRIKA_ID = 105619677;

declare global {
  interface Window {
    ym?: YandexMetrikaFn;
  }
}

type YandexMetrikaFn = ((...args: unknown[]) => void) & {
  a?: unknown[];
  l?: number;
};

export function loadYandexMetrika(): void {
  if (typeof window === 'undefined') return;
  if (document.getElementById('yandex-metrika-script')) return;

  // Minimal loader (official-ish pattern), gated by user consent
  (function (m: Window, e: Document, t: 'script', r: string, i: 'ym') {
    m[i] =
      m[i] ||
      function (...args: unknown[]) {
        const fn = m[i] as YandexMetrikaFn;
        fn.a = fn.a || [];
        fn.a.push(args);
      };
    (m[i] as YandexMetrikaFn).l = Date.now();

    const script = e.createElement(t) as HTMLScriptElement;
    script.async = true;
    script.src = r;
    script.id = 'yandex-metrika-script';
    const firstScript = e.getElementsByTagName(t)[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`, 'ym');

  window.ym?.(METRIKA_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    ssr: true,
  });
}

